import { render, staticRenderFns } from "./plan-info.vue?vue&type=template&id=0c59be21&scoped=true&"
import script from "./plan-info.vue?vue&type=script&lang=js&"
export * from "./plan-info.vue?vue&type=script&lang=js&"
import style0 from "./plan-info.vue?vue&type=style&index=0&id=0c59be21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c59be21",
  null
  
)

export default component.exports